import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke="#E20D1C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m7.383 11.154-.943.943a3.333 3.333 0 1 1-4.714-4.714l.943-.943m8.485.943.943-.943a3.333 3.333 0 1 0-4.714-4.714l-.943.943M4.578 9.245l4.667-4.667"
    ></path>
  </svg>
);

export default SvgIcon;
